import { useContext } from 'react';
import PropTypes from 'prop-types';
import Form from '../form/Form';
import Api from '../../services/ApiService';
import ModalContext from './ModalContext';

const ModalUploadImage = ({ max = 1 }) => {
  const { close, ok } = useContext(ModalContext);

  const layout = [
    {
      name: 'uploadImage',
      type: 'file',
      required: true,
      minListSize: 1,
      maxListSize: max,
    },
  ];

  const submit = payload => {
    return Api.post('chat/file', payload).then(response => {
      ok(response.data);
      return Promise.resolve(response);
    });
  };

  return <Form layout={layout} submit={submit} onCancel={close} feedback="none" hideReset submitAll />;
};

ModalUploadImage.propTypes = {
  max: PropTypes.number,
};

export default ModalUploadImage;
